import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { bundleKeys } from "./bundle-keys";

interface ListBundlesParams {
  limit?: number;
  offset?: number;
  search?: string | undefined;
}

export function useListBundles({ limit = 50, offset = 0, search }: ListBundlesParams = {}) {
  return useQuery({
    queryKey: bundleKeys.list(offset, limit, search),
    queryFn: async () => {
      const query: { limit?: number; offset?: number; search?: string } = { limit };
      if (offset > 0) query.offset = offset;
      if (search) query.search = search;

      const { data, error } = await apiClient.GET("/v1/listings", {
        params: { query },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
